import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1310529c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1310529c&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=1310529c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.106.0__lodash@4_fb6f2845f82ca867f83f204a66169969/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1310529c",
  null
  
)

export default component.exports